import axios from "axios";
import { MessageBox, Message, Confirm } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
import { removeToken } from "@/utils/auth";
import { LOGIN_URL } from "@/utils/lang";
const restfulPath = "/f";

const service = axios.create({
  //https://testcomtrade.drcnet.com.cn/prod-api
  baseURL: process.env.VUE_APP_BASE_API + restfulPath,
  headers: { "api-version": "V1" },
});

service.defaults.timeout = 60 * 3 * 1000; // 30 min

service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers["X-Token"] = getToken();
    }
    config.headers.token = getToken();

    // if (store.getters.token) {
    //   config.headers['X-Token'] = '1123'
    // }
    // config.headers.token = '1123'

    return config;
  },
  (error) => {
    //console.log(error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    // //console.log(response)
    if (
      response.headers["content-type"].includes("text/csv") ||
      response.config.responseType === "blob"
    ) {
      return response;
    }
    const res = response.data;
    if (res.code !== 200) {
      if (res.code == 401) {
        // setTimeout(alert('延时'), 80000 )
        MessageBox.confirm("您的登录已过期，请重新登陆！", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        })
          .then(() => {
            $.ajax({
              url: "http://user.drcnet.com.cn/userapi/loginController/initLoginP", //initp 查询目前用户登录状态，logoutp 退出登录
              type: "get",
              dataType: "jsonp", //指定服务器返回的数据类型
              jsonpCallback: "showData", //指定回调函数名称
              xhrFields: { withCredentials: true },
              crossDomain: true,
              async: false,
              success: function (data) {
                // //console.log(data)

                removeToken();
                window.location.href = LOGIN_URL();
              },
            });
          })
          .catch(() => {
            // window.location.href = LOGIN_URL()
          });
      } else if (
        res.code === 50008 ||
        res.code === 50012 ||
        res.code === 50014
      ) {
        MessageBox.confirm(
          "You have been logged out, you can cancel to stay on this page, or log in again",
          "Confirm logout",
          {
            confirmButtonText: "Re-Login",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        ).then(() => {
          store.dispatch("user/resetToken").then(() => {
            location.reload();
          });
        });
      } else {
        Message({
          message: res.message || "Error",
          type: "error",
          duration: 4 * 1000,
        });
      }
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    //console.log("err" + error); // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
